import { useContext, createContext } from 'react';

function getProvider<T>(): {
  Provider: React.Provider<T | null>;
  useStore: () => T;
} {
  const RootStoreContext = createContext<null | T>(null);

  const Provider = RootStoreContext.Provider;
  function useStore(): T {
    const store = useContext(RootStoreContext);
    if (store === null) {
      throw new Error('Store cannot be null, please add a context provider');
    }
    return store;
  }
  return { Provider, useStore };
}

export default getProvider;
